import React, { ReactNode } from "react";
import { ButtonWrapper } from "../styles/LandingPageForm.styles";

export enum StylisedButtonStyle {
  SALMON = "salmon",
  OUTLINE = "outline",
}

interface StylisedButtonProps {
  isLoading: boolean;
  isLoadingContents?: ReactNode;
  isDisabled: boolean;
  onClick: () => void;
  buttonStartAdornment?: ReactNode;
  buttonText: string;
  isMobile?: boolean;
  style: StylisedButtonStyle;
}

const StylisedButton = ({
  isLoading,
  isLoadingContents,
  isDisabled,
  onClick,
  buttonStartAdornment,
  buttonText,
  isMobile = false,
  style,
}: StylisedButtonProps) => {
  let background = "";
  let border = "";
  let onHoverBackground = "";
  let onHoverBoxShadow = "";
  let onActiveBackground = "";
  let onActiveBoxShadow = "";
  let onDisabledBackground = "";
  let onDisabledBoxShadow = "";
  let onDisabledBorder = "";

  let color = "";
  let fontSize = "";
  let fontWeight = "";
  let lineHeight = "";
  let onHoverFontWeight = "";
  let onActiveColor = "";
  let onDisabledColor = "";

  switch (style) {
    case "salmon":
      background = "#FC4C4C";
      onHoverBackground = "#FEDBDB";
      onHoverBoxShadow = "0px 4px 24px 0px rgba(255, 57, 57, 0.15)";
      onActiveBackground = "#FFF6F6";
      onDisabledBackground = "#D1D4D6";

      color = "#FFF";
      fontSize = "18px";
      fontWeight = "600";
      lineHeight = "22px";
      onActiveColor = "#FC4C4C";
      onDisabledColor = "#9CA3A8";
      break;
    case "outline":
      background = "#FFF";
      border = "1px solid #E5E9EB";
      onHoverBackground = "#F8F9F9";
      onActiveBackground = "#E5E9EB";
      onDisabledBorder = "1px solid #9CA3A8";

      color = "#002035";
      fontSize = "18px";
      fontWeight = "400";
      lineHeight = "22px";
      onHoverFontWeight = "500";
      onDisabledColor = "#9CA3A8";
      break;
  }
  return (
    <ButtonWrapper
      isLoading={isLoading}
      disabled={isDisabled}
      background={background}
      border={border}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      onHoverBackground={onHoverBackground}
      onHoverBoxShadow={onHoverBoxShadow}
      onHoverFontWeight={onHoverFontWeight}
      onActiveBackground={onActiveBackground}
      onActiveBoxShadow={onActiveBoxShadow}
      onActiveColor={onActiveColor}
      onDisabledBackground={onDisabledBackground}
      onDisabledBoxShadow={onDisabledBoxShadow}
      onDisabledBorder={onDisabledBorder}
      onDisabledColor={onDisabledColor}
      onClick={onClick}>
      {isLoading && !!isLoadingContents ? (
        isLoadingContents
      ) : (
        <>
          {!!buttonStartAdornment && buttonStartAdornment}
          {buttonText}
        </>
      )}
    </ButtonWrapper>
  );
};

export default StylisedButton;
